import React from 'react';
import { useQuery } from '@apollo/client/react/hooks';
import { useLocation } from 'react-router';
import queryString from 'query-string';

import PropertyFilter from './property-filter';

import query, { PropertiesQuery, PropertiesQueryVariables } from './properties.graphql';

export interface Props {
    categorySlug: string;
}

const PropertiesFilters: React.FC<Props> = React.memo(props => {
    const location = useLocation();
    const search = queryString.parse(location.search);

    const { categorySlug } = props;

    const { county, price, page, excludeUsed, excludeVendor, search: searchQS, ...rest } = search;
    const countyNames = county
        ? typeof county === 'string'
            ? [county]
            : county.map((name: string) => name)
        : undefined;
    const [priceFrom, priceTo] = price
        ? price
              .split('-')
              .map((e: string) => parseFloat(e))
              .filter((e: number | null | undefined | string) => e != null && e !== '')
        : [];
    const properties = Object.keys(rest).map(key => ({ property: key, value: rest[key] }));

    const { data } = useQuery<PropertiesQuery, PropertiesQueryVariables>(query, {
        variables: {
            categorySlug,
            countyNames,
            priceFrom,
            priceTo,
            properties,
            excludeUsed,
            excludeVendor,
            search: searchQS,
        },
    });

    return data && data.properties && data.properties.properties ? (
        <>
            {data.properties.properties.map(property => (
                <PropertyFilter key={property?.id} {...(property as any)} />
            ))}
        </>
    ) : null;
});

export default PropertiesFilters;
